const TempLogger = {
    extend: () => TempLogger,
    setContextValue: () => { },
    removeContextValue: () => { },
    trace: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.trace(...args);
    },
    isTrace: () => true,
    debug: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.debug(...args);
    },
    isDebug: () => true,
    info: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.info(...args);
    },
    isInfo: () => true,
    warn: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.warn(...args);
    },
    isWarn: () => true,
    error: (...args) => {
        console.warn('[sdk-core] logger called before Streem.configure()');
        console.error(...args);
    },
    isError: () => true,
};
export let logger = TempLogger;
export function setLogger(nextLogger) {
    logger = nextLogger;
}
//# sourceMappingURL=logger.js.map